import Component from "./teamIndicators.component";
import { Config } from "./teamIndicators.config";
import { watchTeamIndicators as saga } from "./redux/teamIndicators.sagas";
import { reducer } from "./redux/teamIndicators.reducer";

export default { Component, saga, reducer, config: Config };
